import { Component, OnInit, Input, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { UserCacheService } from '../../services/user-cache.service';
import { DataService } from '../../services/data.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-search-header',
    templateUrl: './search-header.component.html',
    styleUrls: ['./search-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SearchHeaderComponent implements OnInit, OnDestroy {
  @Input() searchOptions : any
  searchTerm: any;
  searchAccounts = 'All';
  changeStorySubscription: Subscription;
  allAccountdropdownChangeAnnouncment: Subscription;
  public labelDesc: any;
  constructor(public router: Router, public userCacheService: UserCacheService, private dataService: DataService) { }

  ngOnInit(): void {
    // university Dropdown change detection
    this.changeStorySubscription = this.dataService.changeStoryInstance.subscribe(data => {
      if (data.storyId) {
        this.searchAccounts = 'All';
        this.searchTerm = '';
      }
    });

    this.allAccountdropdownChangeAnnouncment = this.dataService.searchAnnouncement.subscribe(data => {
      if (data.storyId) {
        this.searchAccounts = data.storyId;
        this.searchTerm = data.searchKeyword;
      }
    });
  }
  searchStudent(): void{
  if(this.searchTerm && this.searchTerm.trim() && this.searchTerm.trim() !== '') {
    console.log('in search student')
  this.router.navigate(['/secure/students'])
  for(let label of this.searchOptions) {
	if(this.searchAccounts != 'All' && label.id == this.searchAccounts) {
		this.labelDesc = label.label;
	}
}
  this.dataService.allAccountdropdownChangeAnnouncment({storyId:this.searchAccounts, searchKeyword: this.searchTerm.trim(), route: this.router.url, storyValue: this.labelDesc })
  }
}

  ngOnDestroy(): void {
    if (this.changeStorySubscription) {
      this.changeStorySubscription.unsubscribe();
    }
  }

}
